var map = {
	"./0iconmonstr-paintbrush-7.svg": 9589,
	"./1xBlue.png": 118,
	"./2xRed.png": 1748,
	"./3xGreen.png": 7663,
	"./4xGold.png": 9814,
	"./5xGray.png": 9164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1486;